import AuthService from './AuthService';
import ApiService from "./ApiService";

class OrderService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._orderCreate = '/order/create';
        this._basketListUrl = '/profile/basket';
        this._salesListUrl = '/profile/sales';
        this._tableDataBuyer = '/profile/basket/table-data';
        this._tableDataSeller = '/profile/sales/table-data';
        this._deleteUrl = '/order/delete';
        this._updateUrl = '/order/update';
        this._createdOrderInfoUrl = '/order/info';
        this._activePaymentWaysUrl = '/order/info/payment-ways';
    }

    deleteOrder(id) {
        return this.postResource(this._deleteUrl, {id}, this.getBaseHeaders());
    }

    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    getBuyerTableData() {
        return this.postResource(this._tableDataBuyer, {}, this.getBaseHeaders());
    }

    getSellerTableData() {
        return this.postResource(this._tableDataSeller, {}, this.getBaseHeaders());
    }

    getListBasket(params) {
        return this.postResource(this._basketListUrl, params, this.getBaseHeaders());
    }

    getListSales(params) {
        return this.postResource(this._salesListUrl, params, this.getBaseHeaders());
    }

    updateOrder(order) {
        return this.postResource(this._updateUrl, {order}, this.getBaseHeaders());
    }

    getCreatedOrderInfo(params) {
        return this.postResource(this._createdOrderInfoUrl, params, this.getBaseHeaders());
    }

    getActivePaymentWays(params) {
        return this.postResource(this._activePaymentWaysUrl, params, this.getBaseHeaders());
    }
}

const service = new OrderService(AuthService);

export default service;
